import React, { useState, useEffect, useContext, useMemo } from "react";
import { Container, Col, Row, Tab, Tabs } from "react-bootstrap";
import URLstateContext from "./../../../../provider/CommonContext";
import Pagination from './../../../CommonUI/Pagination/Pagination';
import { useParams } from "react-router-dom";
import './MarketShareHolding.css';
import CompanyProfileOptions from "../../CompanyProfileOptions/CompanyProfileOptions";
import { Vortex } from 'react-loader-spinner'
function MarketShareHolding(props) {
    const [showResults, setShowResults] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const [setTextval, setText] = useState([]);
    const [nameCom, setNameCom] = useState([]);
    const [compCode, setCompCode] = useState('');
    let DataFilter = [];
    let getval = [];
    let matchcomp = [];
    let getCoCode = props.coCode;
    let arrayData = [], arrayDataCol = [], arrayColumnData = [];
    let arrayColumn = [];
    const { getCompName } = useParams();
    const [co_code, setco_code] = useState([]);
    const { BaseURL } = useContext(URLstateContext);
    const [chartyearsData, setyearschartData] = useState([]);
    const [data, setData] = useState([]);
    const [chartperiod, setchartperiod] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loadingshow, setloadingshow] = useState(false);
    let getData; let PageSize = 10;
    useEffect(() => {
        setloadingshow(true)
        if (co_code != '') {
            const getUrl = BaseURL + "/MarketShareHolding/";
            fetch(`${getUrl}/${co_code}`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false)
                    // console.log(getData, "MarketShareHolding")
                })
                .catch((error) => {
                });
        }
    }, [co_code])
    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    useEffect(() => {
        const getUrlchart = BaseURL + "getCo_Code";
        fetch(`${getUrlchart}/${getCompName}`)
            .then((response) => response.json())
            .then((data) => {
                setco_code(data.data[0]["co_code"]);
                setNameCom(data.data[0]["lname"]);
                //console.log(data)
            })
            .catch((error) => {
                //console.log("not found the api");
            });
    }, []);

    // const onChangeHandler = event => {
    //     let matches = [];
    //     setText(event.target.value);
    //     if (setTextval.length > 1) {
    //         Loadcompany(setTextval);
    //     }
    //     else {
    //         DataFilter = [];
    //         setSuggestions(DataFilter);
    //     }

    // };
    // function Loadcompany(setTextval) {
    //     setShowResults(true);
    //     const getSectorListUrl = BaseURL + "companysearch/" + setTextval;

    //     fetch(`${getSectorListUrl}`)
    //         .then((response) => response.json())
    //         .then((data) => {
    //             const myrepo = data.data;

    //             getval = myrepo;
    //             for (var i = 0; i < getval.length; i++) {
    //                 DataFilter.push({
    //                     CompName: getval[i]['lname'],
    //                     COCODE: getval[i]['Co_Code'],
    //                     Exchange: getval[i]['Exchange']
    //                 });
    //             }

    //             matchcomp = DataFilter;
    //             setSuggestions(matchcomp);

    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });
    // }
    // const companyClick = (paramcode, paramname, paramexchange) => {
    //     setShowResults(false);
    //     setCompCode(paramcode);
    // }
    
    if (data != null) {
        for (let [key, value1] of Object.entries(data)) {
            for (let [key, value] of Object.entries(value1)) {
                if (value1.COLUMNNAME.includes('+')) {
                    arrayDataCol.push(<td className="headingFin"><b>{(value != null) ? ((typeof value === 'number') ? value.toFixed(2) : value1.COLUMNNAME.split('+')[0]) : '-'}</b></td>);
                }
                else if (value1.COLUMNNAME === "Grand Total") {
                    arrayDataCol.push(<td className="headingFin"><b>{(value != null) ? ((typeof value === 'number') ? value.toFixed(2) : value) : '-'}</b></td>);
                }
                else if (value1.COLUMNNAME === "Year & Month") {
                    if (value1.NOSHARES.toString().slice(-2) === "01") {
                        arrayDataCol.push(<td>{(value != null) ? (value === "Year & Month") ? value : "Jan " + value1.NOSHARES.toString().slice(0, 4) : '-'}</td>);
                    }
                    else if (value1.NOSHARES.toString().slice(-2) === "02") {
                        arrayDataCol.push(<td>{(value != null) ? (value === "Year & Month") ? value : "Feb " + value1.NOSHARES.toString().slice(0, 4) : '-'}</td>);
                    }
                    else if (value1.NOSHARES.toString().slice(-2) === "03") {
                        arrayDataCol.push(<td>{(value != null) ? (value === "Year & Month") ? value : "March " + value1.NOSHARES.toString().slice(0, 4) : '-'}</td>);
                    }
                    else if (value1.NOSHARES.toString().slice(-2) === "04") {
                        arrayDataCol.push(<td>{(value != null) ? (value === "Year & Month") ? value : "April " + value1.NOSHARES.toString().slice(0, 4) : '-'}</td>);
                    }
                    else if (value1.NOSHARES.toString().slice(-2) === "05") {
                        arrayDataCol.push(<td>{(value != null) ? (value === "Year & Month") ? value : "May " + value1.NOSHARES.toString().slice(0, 4) : '-'}</td>);
                    }
                    else if (value1.NOSHARES.toString().slice(-2) === "06") {
                        arrayDataCol.push(<td>{(value != null) ? (value === "Year & Month") ? value : "June " + value1.NOSHARES.toString().slice(0, 4) : '-'}</td>);
                    }
                    else if (value1.NOSHARES.toString().slice(-2) === "07") {
                        arrayDataCol.push(<td>{(value != null) ? (value === "Year & Month") ? value : "July " + value1.NOSHARES.toString().slice(0, 4) : '-'}</td>);
                    }
                    else if (value1.NOSHARES.toString().slice(-2) === "08") {
                        arrayDataCol.push(<td>{(value != null) ? (value === "Year & Month") ? value : "Aug " + value1.NOSHARES.toString().slice(0, 4) : '-'}</td>);
                    }
                    else if (value1.NOSHARES.toString().slice(-2) === "09") {
                        arrayDataCol.push(<td>{(value != null) ? (value === "Year & Month") ? value : "Sept " + value1.NOSHARES.toString().slice(0, 4) : '-'}</td>);
                    }
                    else if (value1.NOSHARES.toString().slice(-2) === "10") {
                        arrayDataCol.push(<td>{(value != null) ? (value === "Year & Month") ? value : "Oct " + value1.NOSHARES.toString().slice(0, 4) : '-'}</td>);
                    }
                    else if (value1.NOSHARES.toString().slice(-2) === "11") {
                        arrayDataCol.push(<td>{(value != null) ? (value === "Year & Month") ? value : "Nov " + value1.NOSHARES.toString().slice(0, 4) : '-'}</td>);
                    }
                    else if (value1.NOSHARES.toString().slice(-2) === "12") {
                        arrayDataCol.push(<td>{(value != null) ? (value === "Year & Month") ? value : "Dec " + value1.NOSHARES.toString().slice(0, 4) : '-'}</td>);
                    }
                    else {
                        arrayDataCol.push(<td>{(value != null) ? (value === "Year & Month") ? value : "-" : '-'}</td>);
                    }
                }
                else
                    arrayDataCol.push(<td>{(value != null) ? ((typeof value === 'number') ? value.toFixed(2) : value) : '-'}</td>);
            }
            arrayData.push(<tr>{arrayDataCol}</tr>);
            arrayColumn.push(<tr>{arrayColumnData}</tr>);
            arrayDataCol = [];
            arrayColumnData = [];
        }
    }


    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/CompanyProfile/Get-Quotes">Company Profile</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Share Holding pattern</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='share-loser-sc'>
                            <div className='score-header'>
                                <h2><span>Share Holding Pattern</span></h2>
                            </div>
                            <CompanyProfileOptions compOption="Share Holding Pattern" />
                            <div>
                                <h4 className="text-center comp-name">{(nameCom != null) ? nameCom : ''}</h4>
                            </div>
                            <div className="table-class">
                                <div className='Buyer-sel-table table-responsive'>
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th className='text-left'>Category of Shareholder</th>
                                                <th className='text-right'>No of Shares</th>
                                                <th className='text-right'>Share Holdings</th>
                                                <th className='text-right'>Demat Shares</th>
                                                <th className='text-right'>Share holders</th>
                                            </tr>
                                        </thead>
                                        {(data === null) ? <div className="errormsgComNew"><h3>No Data Found !!!</h3></div> : ''}
                                        <tbody>
                                            {arrayData}
                                        </tbody>
                                    </table>
                                    {loadingshow ? <div className="textcentervertex">
                                        <Vortex
                                            visible={true}
                                            height="80"
                                            width="80"
                                            ariaLabel="vortex-loading"
                                            wrapperStyle={{}}
                                            wrapperClass="vortex-wrapper"
                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                        />
                                        <div className="model_popup">Please Wait...</div>
                                    </div> : ""
                                    }
                                </div>
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>


        </>
    )
}

export default MarketShareHolding
